import React from 'react';
import { Box } from 'lucide-react';

interface EmptyStateProps {
  message: string;
  action?: React.ReactNode;
  title?: string;
  icon?: React.ReactNode;
}

/**
 * Polished empty state with optional title, icon, and CTA
 */
const EmptyState: React.FC<EmptyStateProps> = ({ message, action, title, icon }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-10 text-center shadow-sm">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-500">
        {icon || <Box className="h-6 w-6" />}
      </div>
      {title && <h3 className="text-lg font-semibold text-gray-900">{title}</h3>}
      <p className="mt-1 max-w-md text-sm text-gray-600">{message}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};

export default EmptyState;
